var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CardHolder Standard1",class:_vm.classList,on:{"click":_vm.clicked}},[_c('div',{staticClass:"Card",class:_vm.color,domProps:{"innerHTML":_vm._s(_vm.cardHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }